import React from 'react';
import * as _ from 'lodash';
import { FieldContractorUserService } from '../../../services/FieldContractorUsers';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import {
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../../CommonFormComponents';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import { REQUEST_PARAMS } from '../../../../src/utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';

/**
 * 安全当番ユーザー単一選択ドロップダウン
 */
export class SafetyDutyUserDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: SessionStorageService.getFieldId(),
      loaded: false,
      allLoaded: false,
      opened: false,
      selected: null,
      options: [],
      condition: {
        name: '',
      },
      offset: 0,
      temporarySelected: null,
      selectedName: '',
      temporarySelectedName: '',
      isLoading: true, // ロード中フラグ
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.getSafetyDutyUsers = this.getSafetyDutyUsers.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleInview = this.handleInview.bind(this);
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    this.getSafetyDutyUsers();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.value &&
      _.isArray(nextProps.value) &&
      nextProps.value.length === 1 &&
      parseInt(nextProps.value[0], 10) !== this.state.selected
    ) {
      // 初期値が設定されていた場合はselectedへセット
      this.setState({
        selected: parseInt(nextProps.value[0], 10),
        temporarySelected: parseInt(nextProps.value[0], 10),
        selectedName: nextProps.name || '',
        temporarySelectedName: nextProps.name || '',
      });
    } else if (
      nextProps.value &&
      _.isArray(nextProps.value) &&
      nextProps.value.length === 0
    ) {
      // 空配列が指定されている場合は非選択状態にする
      this.setState({
        selected: null,
        temporarySelected: null,
        selectedName: '',
        temporarySelectedName: '',
      });
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(props, state) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.resetSelected();
  };

  /**
   * 値を変更前に戻す
   */
  resetSelected() {
    const state = this.state;
    state.opened = false;
    state.temporarySelected = state.selected;
    state.temporarySelectedName = state.selectedName;
    this.setState(state);
  }

  /**
   * 開閉イベント
   */
  handleOpen = () => {
    const state = this.state;
    // 初期化
    if (!this.state.opened) {
      state.temporarySelected = state.selected;
      state.opened = true;
      this.setState(state);
    } else {
      this.resetSelected();
    }
  };

  /**
   * 検索条件セット
   */
  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition });

    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.search();
    }, 1000);
  };

  /**
   * 検索
   */
  search = () => {
    this.setState(
      {
        options: [],
        loaded: false,
        allLoaded: false,
        selected: null,
        isLoading: true,
      },
      () => {
        this.getSafetyDutyUsers();
      }
    );
  };

  handleInview() {
    if (this.state.loaded && !this.state.allLoaded) {
      this.setState({
        loaded: false,
      });
      this.getSafetyDutyUsers();
    }
  }

  /**
   * 選択肢をクリック
   * @param id {int}
   * @param checked {bool} 選択・未選択判定
   */
  handleSelectedRow = (id, checked) => {
    const state = { ...this.state };
    if (checked) {
      state.temporarySelected = id;
      const selectedRow = _.find(state.options, { user_id: id });
      state.temporarySelectedName = selectedRow.user_name;
    } else {
      state.temporarySelected = null;
      state.temporarySelectedName = null;
    }
    this.setState(state, () => {
      this.setValue();
    });
  };

  clearSelectedRow = () => {
    this.setState(
      { temporarySelected: null, temporarySelectedName: null },
      () => {
        this.setValue();
      }
    );
  };

  /**
   * 「選択」押下時
   */
  setValue = () => {
    const state = this.state;
    state.selected = state.temporarySelected;
    state.selectedName = state.temporarySelectedName;
    this.setState(state);

    if (SessionStorageService.getIsTerm()) {
      if (!(parseInt(this.props.value[0], 10) === this.state.selected)) {
        // プルダウンの呼び出しコンポーネントでの処理
        this.props.onSelectKikan('safety_duty_user', this.state.selected);
      }
    } else {
      this.props.onSelect('safety_duty_user', this.state.selected);
    }

    this.setState({ opened: false });
  };

  async getSafetyDutyUsers() {
    if (this.state.loaded) {
      this.setState({ isLoading: false });
      return;
    }
    const params = {
      field_id: this.state.fieldId,
      is_limit: 1,
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.options),
      name: this.state.condition.name,
      block_flag: 0,
      date_from: SessionStorageService.getFromDate(),
      date_to: SessionStorageService.getToDate(),
    };

    await FieldContractorUserService.list(this.state.fieldId, params).then(
      response => {
        if (response.result) {
          const data = response.data.entities.field_contractor_users;
          const allLoaded = _.size(data) < params.limit;
          const options = _.cloneDeep(this.state.options);
          _.each(data, datum => {
            if (_.findIndex(options, { id: datum.user_id }) < 0) {
              options.push(datum);
            }
          });

          this.setState({
            options,
            loaded: true,
            allLoaded,
            isLoading: false,
          });
        }
      }
    );
  }

  render() {
    const that = this;
    const getName = () => {
      let name = '未選択';

      const option = _.find(this.state.options, {
        user_id: this.state.temporarySelected,
      });
      if (option) {
        name = option.user_name;
      } else {
        name = that.state.temporarySelectedName || name;
      }

      return name;
    };

    return (
      <div className='dropdown-multi-select' ref={this.parent}>
        <div
          className={`dropdown-multi-select__header ${
            this.state.opened ? ' show' : ''
          }`}
        >
          <div
            id={`form-dropdown-btn-${this.uid}`}
            className='dropdown-select'
            onClick={this.handleOpen}
          >
            <span className='dropdown-select__txt'>{getName()}</span>
            <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
          </div>
        </div>
        {this.state.opened && (
          <div
            id={`form-dropdown-list-${this.uid}`}
            className='modal-dropdown dropdown--dropdown-list show'
          >
            <div className='dropdown__item dropdown__item--hidden'>
              <div className='dropdown-multi-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  placeholder={messageUtility.getMessage('I-000-090')}
                  defaultValue={this.state.condition.name}
                  onChange={this.setCondition}
                />
              </div>
              {this.props.isOptional && (
                <div className='dropdown-single-select__item'>
                  <FormDropdownClearButton onClick={this.clearSelectedRow} />
                </div>
              )}
              <div className='dropdown-single-select__item'>
                <div
                  className='dropdown-single-select__scroll'
                  id={this.targetId}
                >
                  <ul className='single-select'>
                    {_.map(this.state.options, (option, index) => (
                      <FormDropdownRadio
                        key={index}
                        option={option}
                        checked={
                          this.state.temporarySelected === option.user_id
                        }
                        targetId={this.id}
                        handleSelectedRow={this.handleSelectedRow}
                        forId={'single-safety-duty-user-id'}
                        column={'user_id'}
                      >
                        {option.user_name}
                      </FormDropdownRadio>
                    ))}
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(this.state.options)}
                      isLoading={this.state.isLoading}
                      callback={this.handleInview}
                      ignoreIndicator={true}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='form-list__alert show'>{this.props.error}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/SafetyDutyUser.jsx